import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SupportRequest,
  SupportRequestState,
} from "src/types/supportRequest.types";

const initialState: SupportRequestState = {
  list: { loading: false, data: null, error: null },
  create: { loading: false, data: null, error: null },
  updateStatus: { loading: false, data: null, error: null },
};

const supportRequestSlice = createSlice({
  name: "supportRequest",
  initialState,
  reducers: {
    // 📥 Fetch Support Requests
    getSupportRequestsListAdminRequest: (
      state,
      action: PayloadAction<{
        page: number;
        limit: number;
        status?: string;
        search?: string;
      }>
    ) => {
      state.list.loading = true;
      state.list.error = null;
    },
    getSupportRequestsListAdminSuccess: (state, action: PayloadAction<any>) => {
      state.list.loading = false;
      state.list.data = action.payload;
    },
    getSupportRequestsListAdminError: (
      state,
      action: PayloadAction<string>
    ) => {
      state.list.loading = false;
      state.list.error = action.payload;
    },

    // 📥 Fetch Support Requests
    getSupportRequestsListTenantRequest: (
      state,
      action: PayloadAction<{
        page: number;
        limit: number;
        status?: string;
        search?: string;
      }>
    ) => {
      state.list.loading = true;
      state.list.error = null;
    },
    getSupportRequestsListTenantSuccess: (
      state,
      action: PayloadAction<any>
    ) => {
      state.list.loading = false;
      state.list.data = action.payload;
    },
    getSupportRequestsListTenantError: (
      state,
      action: PayloadAction<string>
    ) => {
      state.list.loading = false;
      state.list.error = action.payload;
    },

    // ➕ Create Support Request
    createSupportRequestRequest: (
      state,
      action: PayloadAction<SupportRequest>
    ) => {
      state.create.loading = true;
      state.create.error = null;
    },
    createSupportRequestSuccess: (
      state,
      action: PayloadAction<SupportRequest>
    ) => {
      state.create.loading = false;
      state.create.data = action.payload;
    },
    createSupportRequestError: (state, action: PayloadAction<string>) => {
      state.create.loading = false;
      state.create.error = action.payload;
    },
    resetCreateSupportRequest: (state) => {
      state.create = { loading: false, data: null, error: null };
    },

    // ✏️ Update Support Request Status
    updateSupportRequestStatusAdminRequest: (
      state,
      action: PayloadAction<{ _id: string; status: string }>
    ) => {
      state.updateStatus.loading = true;
      state.updateStatus.error = null;
    },
    updateSupportRequestStatusAdminSuccess: (
      state,
      action: PayloadAction<SupportRequest>
    ) => {
      state.updateStatus.loading = false;
      state.updateStatus.data = action.payload;
    },
    updateSupportRequestStatusAdminError: (
      state,
      action: PayloadAction<string>
    ) => {
      state.updateStatus.loading = false;
      state.updateStatus.error = action.payload;
    },
    resetUpdateSupportRequestStatusAdmin: (state) => {
      state.updateStatus = { loading: false, data: null, error: null };
    },
  },
});

export const {
  getSupportRequestsListAdminRequest,
  getSupportRequestsListAdminSuccess,
  getSupportRequestsListAdminError,

  getSupportRequestsListTenantRequest,
  getSupportRequestsListTenantSuccess,
  getSupportRequestsListTenantError,

  createSupportRequestRequest,
  createSupportRequestSuccess,
  createSupportRequestError,
  resetCreateSupportRequest,

  updateSupportRequestStatusAdminRequest,
  updateSupportRequestStatusAdminSuccess,
  updateSupportRequestStatusAdminError,
  resetUpdateSupportRequestStatusAdmin,
} = supportRequestSlice.actions;

export default supportRequestSlice.reducer;
